import script from "./AboutUs.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutUs.vue?vue&type=script&setup=true&lang=js"

import "./AboutUs.vue?vue&type=style&index=0&id=16a4e41d&scoped=true&lang=css"

import exportComponent from "/home/sino/SinoData/jenkins/.jenkins/workspace/enterpriseprodex/sxpf-cms-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16a4e41d"]])

export default __exports__